import IndexedDBPlayerStore from "localstorage/indexedDB/IndexedDBPlayerStore";

/***********************************************************************
 Controller class for user dependent data stored in the indexedDB
 ***********************************************************************/

const indexedDBPlayerStore = new IndexedDBPlayerStore(),
      storageId = "indexeddb";

function read() {

    return new Promise( (resolve) => {
        const resultMap = new Map();

        indexedDBPlayerStore.init().then( (succeeded) => {

            if( !succeeded ){
                resolve( resultMap );
                return;
            }

            indexedDBPlayerStore.each( (lessonId, lessonData) => {

                try {
                    const data = JSON.parse( lessonData );
                    if( isValidEntry( data ) ) {
                        resultMap.set(lessonId, mapEntry(data));
                    }
                }
                catch(e){
                }

            }).then(() => {
                resolve( resultMap );
            });
        });
    });
}

function isValidEntry( data ){
    return data && data.stage;
}

function mapEntry( localStorageValue ) {
    return {
            score : Math.round( localStorageValue.stage.default.score_scaled * 100 ),
            lessonStatus : localStorageValue.stage.default.completion_status,
            lessonLocation : localStorageValue.stage.default.lesson_location
    };
}


// revealing public api
export const IndexedDBDataReader = {
    // public api for config

    /**
     * Gets the storage method for the course.
     *
     * @returns {String} "localstorage"
     */
    getStorageMethod : function() {
        return storageId;
    },

    read : read
};
